import { render, staticRenderFns } from "./compliancePop.vue?vue&type=template&id=15d1c7b4"
import script from "./compliancePop.vue?vue&type=script&lang=js"
export * from "./compliancePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d1c7b4')) {
      api.createRecord('15d1c7b4', component.options)
    } else {
      api.reload('15d1c7b4', component.options)
    }
    module.hot.accept("./compliancePop.vue?vue&type=template&id=15d1c7b4", function () {
      api.rerender('15d1c7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/compliancePop.vue"
export default component.exports